const config = {
  base_url_api: process.env.REACT_APP_BASE_URL_API,
};

export { config };
